interface IOptions {
	query?: any
	documentID?: string
	extraDependencies?: any[]
}

export default (
	resource: 'expense' | 'income',
	type: 'aggregation' | 'list' | 'discrete',
	{ extraDependencies, query, documentID }: IOptions
): string | string[] => {
	if (type === 'list' && !query)
		throw Error('Cuando "type" es "list", la opción "query" debe ser definida')

	if (type === 'discrete' && !documentID)
		throw Error(
			'Cuando "type" es "discrete", la opción "documentID" debe ser definida'
		)

	switch (type) {
		case 'aggregation':
			return [resource, type, query].concat(extraDependencies)

		case 'list':
			return [resource, type, query].concat(extraDependencies)

		case 'discrete':
			return `${resource}${type}${documentID}`

		default:
			throw Error('Argumentos inválidos.')
	}
}
